import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <Container className="mt-5 text-center">
      <Alert variant="danger">
        <h2>🚫 Página No Autorizada</h2>
        <p>No tienes permiso para acceder a esta sección.</p>
        <Button variant="primary" onClick={handleGoBack}>
          Regresar
        </Button>
      </Alert>
    </Container>
  );
};

export default UnauthorizedPage;